import type { ChairListItemDto } from '../types/chair';

/**
 * Chair.name is an optional admin-set position label (docs/tasks/014-users-chairs.md part 3); when
 * empty, falls back to a derived "{orgRole.name} ({orgUnit.name})" label — the single place this
 * fallback is computed, reused by ChairTree/ChairPicker/UserEditDialog's supervisor picker.
 */
export function chairPositionLabel(item: ChairListItemDto): string {
  return item.chair.name || `${item.orgRole.name} (${item.orgUnit.name})`;
}

export function chairLabel(item: ChairListItemDto): string {
  return `${item.user.name} — ${chairPositionLabel(item)}`;
}
